import styled from 'styled-components'

export const StyledBreadcrumbs = styled.div``
